<app-employee-layout selectedComponent="EmploymentRecords">
    <app-employment-records-data-grid [employeeId]="employeeId"></app-employment-records-data-grid>
</app-employee-layout>

